export default "__VITE_ASSET__QwEetDsd__"